import styled from 'styled-components';

export const HeaderContainer = styled.header`
    width: 100%;
    height: 64px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 24px;
    box-sizing: border-box;
    background: #fff;
    border-bottom: 1px solid #e5e7eb;
    position: sticky;
    top: 0;
    z-index: 100;
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);

    @media screen and (max-width: 600px){
        padding: 0 16px;
        height: 56px;
    }
`;

export const GoBackButton = styled.button`
    width: 40px;
    height: 40px;
    border: none;
    background-color: #f3f4f6;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
    transition: all 0.2s ease;

    &:hover {
        background-color: #e5e7eb;
        transform: translateX(-2px);
    }

    &:active {
        transform: translateX(-1px);
    }

    & > svg {
        color: #028322;
    }
`;

export const ProfileButton = styled.button`
    width: 40px;
    height: 40px;
    border: none;
    background: linear-gradient(135deg, #028322 0%, #026d1b 100%);
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    transition: all 0.2s ease;
    box-shadow: 0 2px 4px rgba(2, 131, 34, 0.2);

    &:hover {
        transform: scale(1.05);
        box-shadow: 0 4px 8px rgba(2, 131, 34, 0.3);
    }

    &:active {
        transform: scale(0.98);
    }

    & > svg {
        color: #fff;
    }
`;

export const Link = styled.a`
    text-decoration: none;
    color: #374151;
    display: flex;
    align-items: center;
    cursor: pointer;
    height: 40px;
    padding: 0 16px;
    box-sizing: border-box;
    border-radius: 8px;
    font-size: 14px;
    font-weight: 500;
    font-family: Inter, sans-serif;
    transition: all 0.2s ease;
    position: relative;
    margin: 0 4px;

    &:hover{
        background-color: #f0fdf4;
        color: #028322;
    }

    ${({ active }) => active ? `
        background-color: #028322;
        color: #fff;
        box-shadow: 0 2px 4px rgba(2, 131, 34, 0.2);

        &:hover {
            background-color: #026d1b;
            color: #fff;
        }
        ` : `
        background-color: transparent;
        `}
`;

export const NavContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
    margin-right: auto;
    margin-left: 16px;
    background-color: #f9fafb;
    padding: 4px;
    border-radius: 10px;

    @media screen and (max-width: 768px){
        display: none;
    }
`;

export const SearchContainer = styled.div`
    width: 400px;
    max-width: 500px;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 16px;
    box-sizing: border-box;
    background-color: #f9fafb;
    border: 2px solid ${props => props.searchFocus ? '#028322' : '#e5e7eb'};
    border-radius: 12px;
    z-index: 100;
    transition: all 0.25s ease;
    position: relative;

    @media screen and (max-width: 600px){
        padding: 0 12px;
        display: none;
    }

    ${({ searchFocus }) => searchFocus ? `
        box-shadow: 0 4px 6px -1px rgba(2, 131, 34, 0.1), 0 2px 4px -1px rgba(2, 131, 34, 0.06);
        background-color: #fff;
        ` : `
        &:hover {
            border-color: #d1d5db;
        }
        `}
`;

export const SearchInput = styled.input`
    width: 100%;
    height: 46px;
    border: none;
    outline: none;
    background-color: transparent;
    padding: 0;
    box-sizing: border-box;
    font-size: 14px;
    font-weight: 400;
    font-family: Inter, sans-serif;
    color: #111827;

    &::placeholder{
        color: #9ca3af;
    }
`;

export const SearchContent = styled.div`
    width: 100%;
    height: 300px;
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 0 0px;
    box-sizing: border-box;
    overflow-y: scroll;

    &::-webkit-scrollbar{
        width: 6px;
    }
    &::-webkit-scrollbar-thumb{
        background-color: #028322;
        border-radius: 3px;
    }
    &::-webkit-scrollbar-track{
        background-color: #f3f4f6;
    }
`;

export const SearchResultsContainer = styled.div`
    width: 100%;
    height: auto;
    max-height: calc(100vh - 80px);
    position: absolute;
    top: 56px;
    left: 0;
    background-color: #fff;
    z-index: 100;
    display: ${props => props.show ? 'block' : 'none'};
    overflow: auto;
    border-radius: 12px;
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
    border: 1px solid #e5e7eb;

    &::-webkit-scrollbar{
        width: 6px;
    }
    &::-webkit-scrollbar-thumb{
        background-color: #028322;
        border-radius: 3px;
    }
    &::-webkit-scrollbar-track{
        background-color: #f3f4f6;
    }
`;

export const SearchResultSection = styled.div`
    display: flex;
    padding: 12px 16px;
    border-bottom: 1px solid #e5e7eb;
    background-color: #f9fafb;
    font-size: 14px;
    font-weight: 600;
    gap: 10px;
    align-items: center;
    color: #111827;
    font-family: Inter, sans-serif;
`;

export const SearchResultItem = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 12px 16px;
    border-bottom: 1px solid #f3f4f6;
    cursor: pointer;
    background-color: #fff;
    transition: all 0.15s ease;

    &:hover {
        background-color: #f0fdf4;
        padding-left: 20px;
    }

    &:last-child {
        border-bottom: none;
    }

    img {
        width: 40px;
        height: 40px;
        object-fit: cover;
        border-radius: 8px;
        border: 1px solid #e5e7eb;
    }

    span {
        font-size: 14px;
        color: #374151;
        font-family: Inter, sans-serif;
    }
`;

export const ResultCount = styled.span`
    font-size: 12px;
    font-weight: normal;
    color: #6b7280;
    background-color: #e5e7eb;
    padding: 2px 8px;
    border-radius: 12px;
`;

export const ViewAllButton = styled.span`
    font-size: 13px;
    font-weight: 500;
    color: #028322;
    margin-left: auto;
    cursor: pointer;
    padding: 4px 12px;
    border-radius: 6px;
    transition: all 0.15s ease;

    &:hover {
        background-color: #f0fdf4;
    }
`;
